import React, { useState, useEffect } from 'react';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { ManagementActions } from '../../../Services/_actions/index.js';

interface ProfileDropdownProps {
  value: any;
  onChange: (value: any) => void;
  organisationId: string;
  multiSelect?: boolean;
  label?: string;
}

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({
  value,
  onChange,
  organisationId,
  multiSelect = false,
  label = 'Select Profile',
}) => {
  const actions = ManagementActions();
  const [profiles, setProfiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const fetchProfiles = async () => {
  setLoading(true);
  try {
    const payload = organisationId ? { organisationId, page: 0, search: '' } : { page: 0, search: '' };
    const res = await actions.getProfileList(payload);
    if (res?.status === 200) setProfiles(res?.data?.list || []);
  } catch (err) {
    console.error('Failed to load profiles:', err);
  } finally {
    setLoading(false);
  }
};


  // const fetchProfiles = async () => {
  //   if (!organisationId) return;
  //   setLoading(true);
  //   try {
  //     const res = await actions.getProfileList({ organisationId, page: 0, search: '' });
  //     if (res?.status === 200) setProfiles(res?.data?.list || []);
  //   } catch (err) {
  //     console.error('Failed to load profiles:', err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    fetchProfiles();
  }, [organisationId]);

  return (
    <SearchableDropdown
      options={profiles}
      value={value}
      onChange={onChange}
      labelKey="name"
      valueKey="id"
      multiSelect={multiSelect}
      label={label}
      loading={loading}
    />
  );
};

export default ProfileDropdown;
